<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电桩信息</span>
        <el-button type="success" plain class="title-btn" @click="startCharge">启动充电</el-button>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div class>
        <SForm
          ref="formref"
          :fields="formfields"
          :data-form="rowdata"
          label-width="100px"
          :is-show-btn="false"
          :inline="true"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电枪信息</span>
      </div>
      <div class>
        <SForm
          ref="editformref"
          :fields="editformfields"
          :data-form="rowdata"
          label-width="100px"
          :is-show-btn="false"
          :inline="true"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电枪修改信息</span>
      </div>
      <div class>
        <SForm
          ref="lastformref"
          :fields="lastformfields"
          :data-form="rowdata"
          label-width="100px"
          :is-show-btn="false"
          :inline="false"
        />
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">充电单价</span>
      </div>
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <STable
          v-if="showTable"
          ref="tableref"
          :selection="false"
          :columns="columns"
          :list-data="listData"
        />
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host'
import times from './data.json'
export default {
  name: 'Chongdianqiangxiangqing',
  components: {},
  data() {
    return {
      // url: "/station/equipment/page",
      showTable: false,
      editForm: {
        calculateMode: [],
        onTime: [],
        byVolume: []
      },
      equipmentId: '',
      stationId: '',
      listData: [],
      columns: [
        {
          label: '时段',
          prop: 'loginName'
        },
        {
          label: '电费（元/度）',
          prop: 'userName'
        },
        {
          label: '服务费（元/度）',
          prop: 'roleNames'
        }
      ],
      columns1: [
        {
          label: '时段',
          prop: 'loginName'
        },
        {
          label: '单价（元/度）',
          prop: 'userName'
        }
      ],

      // 电桩信息
      rowdata: {},
      formfields: [
        {
          label: '电桩编码',
          type: 'div',
          prop: 'equipmentCode'
        },
        {
          label: '电桩类型',
          type: 'div',
          prop: 'type'
        },
        {
          label: '品牌型号',
          type: 'div',
          prop: 'equipBrandName'
        },
        {
          label: '电桩国标',
          type: 'div',
          prop: 'equipmentInternationalValue'
        },
        {
          label: '电桩功率',
          type: 'div',
          prop: 'equipPower',
          unit: 'KW'
        },
        {
          label: '辅助电源支持',
          type: 'div',
          prop: 'supPower',
          unit: 'V'
        },
        {
          label: '输入电压',
          type: 'div',
          prop: 'inputV',
          unit: 'V'
        },
        {
          label: '最大电压',
          type: 'div',
          prop: 'maxV',
          unit: 'V'
        },
        {
          label: '最小电压',
          type: 'div',
          prop: 'minV',
          unit: 'V'
        },
        {
          label: '最大电流',
          type: 'div',
          prop: 'maxA',
          unit: 'A'
        },
        {
          label: '最小电流',
          type: 'div',
          prop: 'minA',
          unit: 'A'
        },
        {
          label: '恒功率区间',
          type: 'div',
          prop: 'section'
        }
      ],
      formbefore: (record) => {
        console.log(record)
        return record
      },
      editformfields: [
        {
          label: '充电枪编码',
          type: 'div',
          prop: 'connectorCode'
        },
        {
          label: '充电枪名称',
          type: 'div',
          prop: 'connectorName'
        },
        {
          label: '启停状态',
          type: 'div',
          prop: 'disable'
        },
        {
          label: '工作状态',
          type: 'div',
          prop: 'workStatus'
        },
        {
          label: '归属电站',
          type: 'div',
          prop: 'stationName'
        },
        {
          label: '电站属性',
          type: 'div',
          prop: 'attrValue'
        },
        {
          label: '投运时间',
          type: 'div',
          prop: 'operatorTime'
        },
        {
          label: '协议版本',
          type: 'div',
          prop: 'agreementVersionValue'
        },
        {
          label: '通讯运营商',
          type: 'div',
          prop: 'communicationOperator'
        },
        {
          label: 'SIM卡号',
          type: 'div',
          prop: 'SIMNum'
        },
        {
          label: '设备生产日期',
          type: 'div',
          prop: 'productionDate'
        },
        {
          label: '车位号',
          type: 'div',
          prop: 'parkNo'
        },
        {
          label: '有无地锁',
          type: 'div',
          prop: 'parkLock'
        },
        {
          label: '充电枪二维码',
          imageSrc: '',
          type: 'image'
        }
      ],
      editformbefore: (record) => {
        console.log(record)
        return record
      },
      lastformfields: [
        {
          label: '创建人',
          type: 'div',
          prop: 'creater'
        },
        {
          label: '创建时间',
          type: 'div',
          prop: 'createTime'
        },
        {
          label: '修改人',
          type: 'div',
          prop: 'updater'
        },
        {
          label: '修改时间',
          type: 'div',
          prop: 'updateTime'
        }
      ],
      lastformbefore: (record) => {
        console.log(record)
        return record
      },
      connectorId: '',
      connectorCode: ''
    }
  },
  computed: {},
  mounted() {
    if (this.connectorId) {
      const data = {
        connectorId: this.connectorId
      }
      this.$store.dispatch('form/handle', {
        url: '/station/equipment/getDataDetail',
        data: data,
        method: 'get',
        callback: (resp) => {
          console.log('resp', resp)
          this.rowdata = resp
          if (resp.disable === true) {
            this.rowdata.disable = '停用'
          } else if (resp.disable === false) {
            this.rowdata.disable = '启用'
          }

          if (resp.parkLock === true) {
            this.rowdata.parkLock = '有'
          } else if (resp.parkLock === false) {
            this.rowdata.parkLock = '无'
          }

          if (resp.equipmentBrand.type == 0) {
            this.rowdata.type = '直流'
          } else if (resp.equipmentBrand.type == 1) {
            this.rowdata.type = '交流'
          } else if (resp.equipmentBrand.type == 2) {
            this.rowdata.type = '交直流一体'
          }

          this.rowdata.equipPower = resp.equipmentBrand.equipPower
          this.rowdata.supPower = resp.equipmentBrand.supPower
          this.rowdata.inputV = resp.equipmentBrand.inputV
          this.rowdata.maxV = resp.equipmentBrand.maxV
          this.rowdata.minV = resp.equipmentBrand.minV
          this.rowdata.maxA = resp.equipmentBrand.maxA
          this.rowdata.minA = resp.equipmentBrand.minA
          this.rowdata.section =
            resp.equipmentBrand.startP + '-' + resp.equipmentBrand.endP
          this.stationId = resp.stationId
          this.equipmentId = resp.equipmentId
          // this.queryFeeAndRange();
          this.listData = []
          // const that = this;
          if (resp.equipFeeRanges.length > 0) {
            console.log(resp.equipFeeRanges.length, 'length', resp.equipFeeRanges)
            resp.equipFeeRanges.forEach((item, index) => {
              const obj = {
                loginName: '',
                userName: '',
                roleNames: ''
              }
              let start = ''
              let end = ''
              times.timeList.forEach((el, em) => {
                if (item.priceStartPeriod === el.value) {
                  start = el.label
                }
                if (item.priceEndPeriod === el.value) {
                  end = el.label
                }
              })
              if (start === '' && end === '') {
                obj.loginName = '其他时段'
              } else {
                obj.loginName = start + '至' + end
              }
              obj.userName = this.getFloat(item.cpoElecMoney)
              obj.roleNames = this.getFloat(item.cpoServiceMoney)
              this.listData.push(obj)
            })
            this.showTable = true
          }
        }
      })
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.connectorId = this.$route.query.connectorId
    this.connectorCode = this.$route.query.connectorCode
    this.editformfields[13].imageSrc = HOST + '/station/equipment/getQRCode' + '?connectorId=' + this.connectorId + '&token=' + window.localStorage.getItem('token')
    console.log(this.editformfields[13].imageSrc, 3333)
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    startCharge() {
      const connectorId = this.connectorId || this.rowdata.connectorId
      if (!connectorId) {
        this.$message.warning('未获取到充电枪ID，无法启动')
        return
      }
      this.$confirm('确定要远程启动该充电枪充电吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('form/handle', {
            url: '/evserv/newApi/start_charge',
            data: { connectorId },
            method: 'post',
            callback: resp => {
              this.$notify({
                title: '成功',
                message: '远程启动充电指令已下发',
                type: 'success'
              })
            }
          })
        })
        .catch(() => {})
    },
    cancel() {
      this.$router.go(-1)
    }
    // queryFeeAndRange() {
    //   let data = {
    //     stationId: this.stationId,
    //     equipmentId: "",
    //   };
    //   this.$store.dispatch("form/handle", {
    //     url: "/station/equipment/getFeeAndRange",
    //     method: "get",
    //     data: data,
    //     callback: (resp) => {
    //       this.listData = [];
    //       const that = this;
    //       if (resp.ranges.length > 0) {
    //         resp.ranges.forEach((item, index) => {
    //           let obj = {
    //             loginName: "",
    //             userName: "",
    //             roleNames: "",
    //           };
    //           let start = "";
    //           let end = "";
    //           times.timeList.forEach((el, em) => {
    //             if (item.priceStartPeriod === el.value) {
    //               start = el.label;
    //             }
    //             if (item.priceEndPeriod === el.value) {
    //               end = el.label;
    //             }
    //           });
    //           if (start === "" && end === "") {
    //             obj.loginName = "其他时段";
    //           } else {
    //             obj.loginName = start + "至" + end;
    //           }
    //           obj.userName = this.getFloat(item.cpoElecMoney);
    //           obj.roleNames = this.getFloat(item.cpoServiceMoney);
    //           that.listData.push(obj);
    //         });
    //       }
    //       this.showTable = true;
    //     },
    //   });
    // },
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/deep/ .el-form-item {
      .el-form-item__content {
        width: calc(100% - 120px);
        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .form-card{
      padding:10px 20px;
      border:1px solid #e0e0e0;
      margin-top:20px;
      .title{
        margin:0 0 10px 0;
      }
    }
</style>



// WEBPACK FOOTER //
// src/views/plantManagement/pileDetail.vue